export default __webpack_public_path__ + "static/media/pg-icon3.2354c2bb.png";